/* eslint-disable react-native/no-inline-styles */
import React from 'react';
import { View, StyleSheet, ScrollView } from 'react-native';

import Colors from '@global/colors';
import { isWeb } from '@global/screens';

import PropTypes from 'prop-types';

const propTypes = {
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};

const defaultProps = {
  style: {},
};

const HeaderRow = (props) => {
  if (isWeb) {
    return (
      <View
        {...props}
        style={[
          styles.headerWrapperWeb,
          styles.headerBorder,
          props.style ? props.style : {},
        ]}
      />
    );
  }
  return (
    <ScrollView
      horizontal
      showsHorizontalScrollIndicator={false}
      style={styles.headerBorder}
      {...props}
    />
  );
};

HeaderRow.propTypes = propTypes;
HeaderRow.defaultProps = defaultProps;

const styles = StyleSheet.create({
  headerWrapperWeb: {
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'space-between',
    backgroundColor: Colors.white,
  },
  headerBorder: { borderBottomColor: Colors.grey0, borderBottomWidth: 1 },
});

export default React.memo(HeaderRow, (prev, next) => prev == next);
